const array = [
  { value: 'ON_DELIVERY', label: 'ON_D' },
  { value: 'RETURNED', label: 'RETN' },
  { value: 'DELIVERED', label: 'DELV' },
  { value: 'BOOKING', label: 'BOOK' },
  { value: 'PICKED', label: 'PICK' },
  { value: 'PENDING', label: 'PEND' },
  { value: 'PARTIALLY_DELIVERED', label: 'PDEL' },
];

export function getLabel(value: string) {
  const item = array.find((item) => item.value === value);
  return item ? item.label : '';
}

export function getParcelPrice(parcel: Record<string, any>) {
  const { status, collected_amount, merchant_COD } = parcel;

  if (status === 'PARTIALLY_DELIVERED') {
    return collected_amount;
  }

  if (status === 'RETURNED') {
    return 0;
  }

  return merchant_COD;
}
